import { Loader } from '../Loader/Loader';

export default function GamesLoader() {
  return (
    <div className="games__loader">
      <Loader />
    </div>
  );
}
